import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MemoizedSelector, Store} from '@ngrx/store';
import {kliknietoDodanjDokumenty} from './store/ekran-koncowy.actions';
import {Subscription} from 'rxjs';
import {correlationIdSelector, linkAnkietaSelector, stanSelector} from '../../store/samoobsluga/samoobsluga.selectors';
import {LoggingService} from '../../services/logging/logging.service';
import {LinkType} from '../../services/logging/types/link-activity-log';
import {NavigationService} from '../../services/navigation/navigation.service';
import {czyIsteniejeUszkodzenieONazwie} from '../../store/zbior-uszkodzen/zbiorUszkodzen.selectors';
import {SlownikUszkodzen} from '../../model/uszkodzenia/slownik-uszkodzen';
import {take} from 'rxjs/operators';
import {selectParametrBiznesowyByName} from '../../store/parametry/parametryBiznesowe.selectosr';
import {adminParametry} from '../../services/admin/admin-parametry';
import {ustawStanKwotaUkryta} from "../../../samoobsluga/proces-decyzji/ekran-braku-prezentacji-kwoty-po-kalkulacji/store/ekran-braku-prezentacji-kwoty-po-kalkulacji.actions";

@Component({
  selector: 'shared-ekran-koncowy',
  templateUrl: './ekran-koncowy.component.html',
  styleUrls: ['./ekran-koncowy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EkranKoncowyComponent implements OnInit, OnDestroy {

  constructor(
    private store: Store,
    private navigation: NavigationService,
    private logger: LoggingService
  ) {}

  @Input()
  numerSzkody = '';

  @Input()
  tenantCC!: boolean;

  @Input()
  tenantKN!: boolean;

  @Input()
  kwotaUkryta: boolean = false;

  private subscriptions: Subscription[] = [];
  private correlationId!: string;
  public linkAnkieta!: string;
  public linkKN!: string;
  public linkCC!: string;
  public linkPAK!: string;

  stanSamoobslugiSubscription!: Subscription;
  stanSamoobslugi!: string;

  protected readonly LinkType = LinkType;

  ngOnInit(): void {
    this.subscriptions.push(
      this.store.select(correlationIdSelector).subscribe(id => this.correlationId = id),
      this.store.select(linkAnkietaSelector).subscribe(link => this.linkAnkieta = link),
      this.store.select(selectParametrBiznesowyByName, adminParametry.PARAMETR_CC_URL_KEY).subscribe((link => this.linkCC = ""+link)),
      this.store.select(selectParametrBiznesowyByName, adminParametry.PARAMETR_KN_URL_KEY).subscribe((link => this.linkKN = ""+link)),
      this.store.select(selectParametrBiznesowyByName, adminParametry.PARAMETR_PAK_URL_KEY).subscribe((link => this.linkPAK = ""+link))
    )
    this.stanSamoobslugiSubscription = this.store.select(stanSelector).subscribe(stan => {
      this.stanSamoobslugi = stan
    });
  }

  logLinkActivity(type: LinkType): void {
    this.logger.logLinkActivity({
      linkType: type,
      page: 'end-page'
    }).subscribe()
  }

  kliknietoDodajDokument(): void {
    this.store.dispatch(kliknietoDodanjDokumenty({correlationId: this.correlationId}));
  }

  createNextClaim() {
    const link = this.tenantCC
        ? this.linkCC
        : this.linkKN;

    this.logLinkActivity(LinkType.CREATE_NEXT_NOTICE);
    this.navigation.navigateToExternalUrl(link);
  }

  goToMojePzu(): void {
    this.logLinkActivity(LinkType.MY_PZU_REDIRECTION);
    this.navigation.navigateToExternalUrl(this.linkPAK);
  }

  zakoncz(): void {
    this.store.dispatch(ustawStanKwotaUkryta({correlationId: this.correlationId, stanSamoobslugi: this.stanSamoobslugi}))
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe())
  }

  typUszkodzeniaMeble(): boolean {
    return this.select(czyIsteniejeUszkodzenieONazwie(SlownikUszkodzen.MEBLE))
  }

  typUszkodzeniaSprzetAgdRtv(): boolean {
    return this.select(czyIsteniejeUszkodzenieONazwie(SlownikUszkodzen.SPRZET_AGD_RTV))
  }

  czyMoznaZglosicKolejnaSprawe(): boolean {
    return (this.typUszkodzeniaMeble() || this.typUszkodzeniaSprzetAgdRtv()) && !this.kwotaUkryta;
  }

  czyMoznaPrzejscNaMojePzu(): boolean {
    return !this.tenantCC && !this.czyMoznaZglosicKolejnaSprawe();
  }

  private select<T>(selector: MemoizedSelector<object, T>): T {
    let result: T | undefined = undefined;
    this.store.select(selector)
      .pipe(take(1)).subscribe(res => result = res)
    return result as T;
  }
}
